<script setup lang="ts">
import { getTranslation } from '@/utils/data-display-utils';
import { Module, ProjectModuleVideoConfigDto } from '@/store/module.interface';
import { constant } from '@/constant';
import VideoPlayer from '../VideoPlayer.vue';
import { Locales } from '@/store/language.interface';

const props = defineProps<{
  module: Module;
  languageEnabled?: Locales[];
}>();

const moduleConfig = props.module.config as ProjectModuleVideoConfigDto;
</script>

<template>
  <div class="video-module-wrapper">
    <div :class="{ highlight: moduleConfig.highlight }">
      <div class="video-module">
        <div
          class="video-module__left-align"
          v-if="moduleConfig.videoAlignment === constant.ProjectModule.Alignment.Left"
        >
          <div class="video-player col">
            <VideoPlayer
              :type="moduleConfig.videoType"
              :video-id="moduleConfig.video"
              :title="moduleConfig.content"
              :language-enabled="props.languageEnabled"
            />
          </div>
          <div class="caption col">
            <h2>{{ getTranslation(props.module, 'title', languageEnabled) }}</h2>
            <div v-html="getTranslation(moduleConfig, 'content', languageEnabled)" />
          </div>
        </div>
        <div
          class="video-module__center-align"
          v-if="moduleConfig.videoAlignment === constant.ProjectModule.Alignment.Center"
        >
          <div class="caption">
            <h2>{{ getTranslation(props.module, 'title', languageEnabled) }}</h2>
            <div v-html="getTranslation(moduleConfig, 'content', languageEnabled)" />
          </div>
          <div class="video-player">
            <VideoPlayer
              :type="moduleConfig.videoType"
              :video-id="moduleConfig.video"
              :title="moduleConfig.content"
              :language-enabled="props.languageEnabled"
            />
          </div>
        </div>
        <div
          class="video-module__right-align"
          v-if="moduleConfig.videoAlignment === constant.ProjectModule.Alignment.Right"
        >
          <div class="caption col">
            <h2>{{ getTranslation(props.module, 'title', languageEnabled) }}</h2>
            <div v-html="getTranslation(moduleConfig, 'content', languageEnabled)" />
          </div>
          <div class="video-player col">
            <VideoPlayer
              :type="moduleConfig.videoType"
              :video-id="moduleConfig.video"
              :title="moduleConfig.content"
              :language-enabled="props.languageEnabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.video-module-wrapper {
  width: 100%;

  .highlight {
    background-color: $color-neutral-grey-blue-150;
    border-radius: 8px;
    padding: $space-lg;
  }

  .video-module {
    display: flex;
    flex-direction: column;
    gap: $space-md;

    h2 {
      margin-bottom: $space-sm !important;
    }

    &__left-align {
      display: flex;
      flex-direction: row;
      gap: $space-md;
    }

    &__right-align {
      display: flex;
      flex-direction: row;
      gap: $space-md;
    }

    &__center-align {
      display: flex;
      flex-direction: column;
      gap: $space-md;
    }
  }
}

@media screen and (max-width: $breakpoint-md) {
  .video-module-wrapper {
    .video-module {
      &__right-align,
      &__left-align {
        flex-direction: column;
      }
    }
  }
}
</style>
